import React from "react";
import { Navigate } from "react-router-dom";
import { getCookie } from "../../utils/cookies";

const PublicRoute = ({ children }) => {
  const token = getCookie("token");

  if (token) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
